import { render, staticRenderFns } from "./haokaByEx9.vue?vue&type=template&id=b82dcb24&scoped=true&"
import script from "./haokaByEx9.vue?vue&type=script&lang=js&"
export * from "./haokaByEx9.vue?vue&type=script&lang=js&"
import style0 from "./haokaByEx9.vue?vue&type=style&index=0&id=b82dcb24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82dcb24",
  null
  
)

export default component.exports